/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_AmountInputs */

const es_billing_alerts_amount = /** @type {(inputs: Billing_Alerts_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monto límite`)
};

const en_billing_alerts_amount = /** @type {(inputs: Billing_Alerts_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit amount`)
};

/**
* | output |
* | --- |
* | "Limit amount" |
*
* @param {Billing_Alerts_AmountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_amount = /** @type {((inputs?: Billing_Alerts_AmountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_AmountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_amount(inputs)
	return en_billing_alerts_amount(inputs)
});
export { billing_alerts_amount as "billing.alerts.amount" }